// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapper":"SiteSettingsWrapper_layoutWrapper__qZ5kk","main":"SiteSettingsWrapper_main__gdlt8"};